import { render, staticRenderFns } from "./OVDetail.vue?vue&type=template&id=1086fc15&scoped=true&lang=pug"
import script from "./OVDetail.vue?vue&type=script&lang=js"
export * from "./OVDetail.vue?vue&type=script&lang=js"
import style0 from "./OVDetail.vue?vue&type=style&index=0&id=1086fc15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1086fc15",
  null
  
)

export default component.exports